import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import { appHref } from '@/config/config'
import { toCamelCase } from '@/lib/typeHelper'

/** One carrier's marketing-site logo tile — see PublicCarrierLogoSerializer. */
export interface PublicCarrierLogo {
  id: string
  name: string
  marketingLogo: string
}

export function usePublicCarrierLogos() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['PUBLIC_CARRIER_LOGOS'],
    queryFn: () =>
      axios
        .get(appHref('/api/v1/insure/public/carrier-logos/'))
        .then((res) => toCamelCase(res.data) as PublicCarrierLogo[]),
    retry: false,
  })
  return { logos: data, isLoading, isError }
}
